import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import {FiGrid, FiList} from 'react-icons/fi';
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Card} from "components/Card/Card.jsx";
import {brandActions} from "../../../redux/actions/brand-actions";
import {listActions} from '../../../redux/actions/list-actions';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import {FormInputs} from "components/FormInputs/FormInputs.jsx";
import {hasPermission} from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import {adminLabels} from '../../../redux/constant/admin-label-constant';
import OpenModalButton from '../../ThemeComponents/openModelButton';
import {helperFunctions as HF} from '../../../helper/helperFunctions';
import {withRouter} from 'react-router-dom';
import AddEditTagLayoutForm from './Forms/AddEditTagLayoutForm';
import SimpleReactValidator from "simple-react-validator";
//import defaultImage from "assets/img/default.jpg";
import TagsGridLayout from "./TagsGridLayout";
import Image from "react-graceful-image";


// add new tag type form component and files //
import ListForm from '../Lists/ListForm';
import {objectsConstants as OC} from 'redux/constant/objects-constant';

// dropdown components //
import BrandsDropdown from "../Brands/BrandsDropdown";
import BrandsDropdownLinks from './BrandsDropdownLinks';

var Modal = require('react-bootstrap-modal');

class TagLayouts extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        let model_id;
        let model;
        if (user.model === 'App\\Brand') {
            model_id = user.model_id;
            model = this.props.match.params.model;
        } else {
            model_id = this.props.match.params.id;
            model = '';
        }

        this.state = {
            loggedInUserType: user.model,
            filtered: '',
            addModal: false,
            editModal: false,
            pageSize: 10,
            initialState: {
                tag: {
                    brand_id: model_id,
                    model: model,
                    title: '',
                    image: '',
                    description: '',
                    vendor_description: '',
                    tag_type: '',
                    barcode: '',
                    status: true,
                    allow_quantity_increase: false,
                    product_filter_value: ''
                }
            },
            formData: {
                tag: {
                    brand_id: model_id,
                    model: model,
                    title: '',
                    image: '',
                    description: '',
                    vendor_description: '',
                    tag_type: '',
                    barcode: '',
                    status: true
                }
            },
            submitted: false,
            listStyle: 'list',
            showDropdown: this.props.match.params.id !== 'all' ? false : true,

            tagTypeList: {},
            tagTypeParentId: '',
            tagTypeAddModal: false,

            model_id: '',

            table_columns: [],
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleEditFormSubmit = this.handleEditFormSubmit.bind(this);
        this.filterSearchHandle = this.filterSearchHandle.bind(this);
    };

    handlePaginationClick = (event) => {
        this.props.getAllTagLayoutsCall(this.state.initialState.tag.brand_id, this.state.filtered, event.target.id, '', this.state.pageSize);
    }

    componentDidMount() {
        const {initialState} = this.state;
        this.setState({
            table_columns: [
                {
                    Header: <div className='text-capitalize'>Tag Layout List</div>,
                    headerClassName: 'headerPagination',
                    columns: [
                        {
                            Header: <div className='text-capitalize'>Title</div>,
                            accessor: "title",
                            className: "action-center text-capitalize"
                        },
                        {
                            Header: <div className='text-capitalize'>Image</div>,
                            accessor: "row",
                            Cell: row => {
                                return (
                                    <div>
                                          <span className="text-capitalize">
                                            <Image
                                                src={process.env.REACT_APP_S3_THUMBNAIL_PATH + row.original.path}
                                                style={{width: "100%"}}
                                                alt="image"
                                                retry={{count: 10, delay: 2}}
                                                placeholderColor="#ccc"
                                            />
                                          </span>
                                    </div>
                                )
                            },
                            className: "action-center",
                            sortable: false,
                        },
                        {
                            Header: <div className='text-capitalize'>Brand</div>,
                            accessor: "brand",
                            className: "action-center text-capitalize"
                        },
                        {
                            Header: <div className='text-capitalize'>Description</div>,
                            accessor: "description",
                            className: "action-center text-capitalize"
                        },
                        {
                            Header: <div className='text-capitalize'>Vendor Description</div>,
                            accessor: "vendor_description",
                            className: "action-center text-capitalize"
                        },
                        {
                            Header: <div className='text-capitalize'>Product Filter</div>,
                            accessor: "product_filter_value",
                            className: "action-center text-capitalize"
                        },
                        {
                            Header: "Actions",
                            accessor: "id",
                            Cell: ({value}) => (
                                <div>
                                    <OverlayTrigger placement="bottom" overlay={<Popover
                                        id="tooltip">{hasPermission('manage-brand-tag-layouts') ? `Edit TagLayout` : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                        hasPermission('manage-brand-tag-layouts') &&
                        <button type='button' className="editIcon orderDetailsAction "
                                onClick={() => this.editTagLayoutCall(value)}>&nbsp;</button>

                    }
                      {
                          !hasPermission('manage-brand-tag-layouts') &&
                          <button type='button' className="editIcon orderDetailsAction button_disabled">&nbsp;</button>
                      }
                  </span>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="bottom" overlay={<Popover
                                        id="tooltip">{hasPermission('manage-brand-tag-layouts') ? `Delete TagLayout` : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                        hasPermission('manage-brand-tag-layouts') &&
                        <button type='button' className="deleteIcon orderDetailsAction"
                                onClick={() => this.deleteConfirmListItem(value)}>&nbsp;</button>
                    }
                      {
                          !hasPermission('manage-brand-tag-layouts') &&
                          <button type='button'
                                  className="deleteIcon orderDetailsAction button_disabled">&nbsp;</button>
                      }
                  </span>
                                    </OverlayTrigger>
                                </div>
                            ),
                            className: "action-center",
                            sortable: false
                        }
                    ]
                }
            ]
        })
        this.props.getListCall('tagtype', "", "", "", "", "tagtype", false);
    }

    handleFormSubmit(data) {
        if (this.validator.allValid()) {
            const {initialState} = this.state;
            const fd = new FormData();
            for (const key in this.state.formData.tag) {
                fd.append(key, this.state.formData.tag[key]);
            }
            fd.append('brand_id', initialState.tag.brand_id)
            this.props.storeTagLayoutCall(fd).then(res => {
                this.props.getAllTagLayoutsCall(initialState.tag.brand_id, this.state.filtered, 1, '', this.state.pageSize);
                this.setState({
                    ...this.state,
                    addModal: false,
                    formData: initialState
                });
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    handleEditFormSubmit(data) {
        if (this.validator.allValid()) {
            this.setState({
                submitted: true
            });
            const {initialState} = this.state;
            const fd = new FormData();
            for (const key in this.state.formData.tag) {
                fd.append(key, this.state.formData.tag[key] || '');
            }
            fd.append('_method', 'put');
            this.props.updateTagLayoutCall(fd, this.state.formData.tag.id).then(res => {
                this.props.getAllTagLayoutsCall(initialState.tag.brand_id, this.state.filtered, this.props.current_page, '', this.state.pageSize);
                this.setState({
                    ...this.state,
                    editModal: false,
                    formData: initialState
                });
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    filterSearchHandle(e) {
        var value = e.target.value;
        this.setState({
            'filtered': value
        });

        this.props.getAllTagLayoutsCall(this.state.initialState.tag.brand_id, value, this.props.current_page, '', this.state.pageSize);
    }

    getState = state => {
        if (state.tagTypeAddModal !== undefined) {
            this.setState(prevState => ({
                ...prevState.tagTypeAddModal,
                ...state
            }));
        } else {
            this.setState(prevState => ({
                formData: {
                    ...prevState.tag,
                    ...state
                }
            }));
        }
    };

    editTagLayoutCall = (id) => {
        this.props.getTagLayoutCall(id).then(response => {
            this.setState(prevState => ({
                formData: {
                    ...prevState.tag,
                    ...this.props.taglayout
                },
                editModal: true
            }));
        });
    }

    deleteListItem = (list_id) => {
        const {initialState} = this.state;
        this.props.deleteListCall(list_id).then(response => {
            this.props.getAllTagLayoutsCall(initialState.tag.brand_id, this.state.filtered, this.props.current_page, '', this.state.pageSize);
        });
    }

    deleteConfirmListItem = (list_id) => {
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Confirmalertfordelete typeName="Tag Layout" onClosePro={onClose}
                                           deleteType={() => this.deleteListItem(list_id)}/>
                )
            }
        })
    }

    listingPaginationData = (id, filter, page, sort, pageSize) => {
        const {initialState} = this.state;
        this.setState({pageSize: pageSize}, function () {
            this.props.getAllTagLayoutsCall(initialState.tag.brand_id, this.state.filtered, page, sort, pageSize);
        });
    }

    toggleLayout = (style) => {
        this.setState({
            listStyle: style
        });
    }

    handleTagTypeSubmit = (listData, formType) => {
        var list = {
            title: listData.title,
            list_type_id: 5,
            list_type: "tagtype",
            component_name: "Tag Type"
        };

        this.props.storeTagTypeCall(list).then(
            response => {
                this.props.getListCall('tagtype', "", "", "", "", "tagtype", false);
                this.setState({
                    ...this.state,
                    tagTypeAddModal: false,
                });
            },
            error => {
                return error;
            }
        );
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.model !== prevProps.match.params.model) {
            window.location.reload();
        }
        if (prevProps.listData !== this.props.listData) {
            this.setState({
                listData: this.props.listData
            })
        }

        if (this.props.match.params.id !== 'all' && this.props.match.params.id !== prevProps.match.params.id) {
            this.props.getAllTagLayoutsCall(this.props.match.params.id, 1, this.state.filtered, '', this.state.pageSize);
        }
    }

    getFullState = state => {
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                tag: {
                    ...prevState.formData.tag,
                    brand_id: state.model_id
                }
            },
            initialState: {
                ...prevState.initialState,
                tag: {
                    ...prevState.initialState.tag,
                    brand_id: state.model_id
                }
            }
        }), () => {
            if (this.state.initialState.tag.brand_id !== 'all')
                this.props.getAllTagLayoutsCall(this.state.initialState.tag.brand_id, this.state.filtered, 1, '', this.state.pageSize);
        });
    }

    checkImage = (src, good, bad, id) => {
        var img = new Image();
        img.onload = good;
        img.onerror = bad;
        img.src = src;
    }

    getModelId = (id) => {
        this.setState({
            model_id: id,
        }, () => {
            this.props.history.push(`/Admin/brand/${this.state.model_id}/tag-layouts`);
        })
    }

    render() {
        const {initialState} = this.state;
        const {pages, loading} = this.props;
        return (
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            {this.state.showDropdown && (
                                                <div
                                                    className="col-md-5"
                                                    style={{paddingRight: "10px", float: "right"}}
                                                >
                                                    <BrandsDropdown
                                                        onReturnFullState={this.getFullState}
                                                        stateProp={this.state}
                                                        selectedCustomer={initialState.tag.brand_id}
                                                        modelProp={this.state.loggedInUserType}
                                                    />
                                                </div>
                                            )}
                                            {!this.state.showDropdown && (
                                                <div
                                                    className="col-md-4 pull-right"
                                                >
                                                    <BrandsDropdownLinks
                                                        returnModelId={this.getModelId}/>
                                                </div>
                                            )}

                                            <Grid fluid>
                                                <Row>
                                                    <Col md={12}>
                                                        <h3 style={{
                                                            textAlign: 'center',
                                                            fontWeight: "500",
                                                            textTransform: "capitalize"
                                                        }}>Tag Layouts</h3>
                                                    </Col>

                                                    <Col md={12}>
                                                        <div className="flexElem mt-xlg flexResponsive" style={{
                                                            "alignItems": "flex-start",
                                                            "justifyContent": "space-between"
                                                        }}>
                                                            <div className="block">
                                                                {(initialState.tag.brand_id !== 'all' && initialState.tag.brand_id !== undefined) &&
                                                                <OpenModalButton
                                                                    openModal={hasPermission('manage-brand-tag-layouts') ? HF.openModal.bind(this, "addModal") : null}
                                                                    classButton={['customBtn btnBlue', !hasPermission('manage-brand-tag-layouts') ? 'button_disabled' : '']}
                                                                    buttonName={'Add Tag Layout'}
                                                                    tooltipText={`Add Tag Layout`}
                                                                    classIcon={['']}
                                                                />
                                                                }
                                                                {(initialState.tag.brand_id === undefined || initialState.tag.brand_id === 'all') &&
                                                                <OpenModalButton
                                                                    classButton={['customBtn btnBlue button_disabled']}
                                                                    buttonName={'Add Tag Layout'}
                                                                    tooltipText={'Please select brand to Add new tag layout'}
                                                                    classIcon={['']}
                                                                />
                                                                }
                                                            </div>

                                                            <div className="custom-search-input">
                                                                <FormInputs
                                                                    ncols={["col-md-12"]}
                                                                    onChange={this.filterSearchHandle}
                                                                    proprieties={[
                                                                        {
                                                                            type: "text",
                                                                            bsClass: "form-control",
                                                                            placeholder: "Search Tag Layouts",
                                                                            onChange: this.filterSearchHandle,
                                                                            name: "filter"
                                                                        }
                                                                    ]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Col>

                                                    <Col md={12}>
                                                        <Row>
                                                            <div className="btn-group" style={{
                                                                margin: '0 auto',
                                                                display: "table",
                                                                marginTop: "10px"
                                                            }} role="group">
                                                                <button type="button"
                                                                        onClick={() => this.toggleLayout('list')}
                                                                        className="btn btn-default toggler">
                                                                    <div className="inlineFlexElem alignCenter">
                                                                        <FiList/> <span className="ml-xs">List</span>
                                                                    </div>
                                                                </button>
                                                                <button type="button"
                                                                        onClick={() => this.toggleLayout('grid')}
                                                                        className="btn btn-default toggler">
                                                                    <div className="inlineFlexElem alignCenter">
                                                                        <FiGrid/> <span className="ml-xs">Grid</span>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </Row>
                                                    </Col>

                                                    <Col md={12} className="mt-xlg">
                                                        {
                                                            this.state.listStyle === 'grid' &&
                                                            <TagsGridLayout
                                                                noDataText='No data found'
                                                                tagsData={this.props.taglayoutsData}
                                                                onDeleteListItem={this.deleteListItem}
                                                                editTagLayoutCall={this.editTagLayoutCall}
                                                                tagObject={this.state.formData}
                                                                tagProp={this.state.initialState}
                                                                returnState={this.getState}
                                                                fullProps={this.props}
                                                                onhandlePaginationClick={this.handlePaginationClick}
                                                                checkImage={this.checkImage}
                                                            />
                                                        }

                                                        {
                                                            this.state.listStyle === 'list' &&
                                                            <ReactTable
                                                                noDataText='No data found'
                                                                data={this.props.taglayoutsData}
                                                                pages={pages}
                                                                loading={loading}
                                                                columns={this.state.table_columns}
                                                                defaultPageSize={10}
                                                                className="-striped listing responsive"
                                                                pageData={this.listingPaginationData}
                                                                manual
                                                                onFetchData={(state, instance) => {
                                                                    var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                                                    var brand_id = this.state.initialState.tag.brand_id;
                                                                    state.pageData(brand_id, state.filter, state.page + 1, sort, state.pageSize);
                                                                }}
                                                            />
                                                        }
                                                    </Col>
                                                </Row>
                                            </Grid>

                                            {/*Add Tag Modal Start*/}
                                            {this.props.TagLayoutData !== null &&
                                            <Modal show={this.state.addModal}
                                                   onHide={HF.closeModal.bind(this, "addModal")}
                                                   aria-labelledby="ModalHeader"
                                                   backdrop={false}
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader'
                                                                 className="headerTitle text-capitalize">Add New Tag
                                                        Layout</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <AddEditTagLayoutForm
                                                                closeModel={HF.closeModal.bind(this, "addModal")}
                                                                formTypePro="add"
                                                                requiredField={{
                                                                    tag_type: "required",
                                                                    barcode: "required",
                                                                    title: "required",
                                                                    description: "required",
                                                                    vendor_description: "required"
                                                                }}
                                                                tagtypesProp={this.props.tagtypes}
                                                                tagObject={this.state.tag}
                                                                tagProp={this.state.initialState.tag}
                                                                validatorInstance={this.validator}
                                                                returnState={this.getState}
                                                                handleFormSubmitProp={this.handleFormSubmit}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                            }
                                            {/*Add Country Modal End*/}

                                            {/*Edit Modal Start*/}
                                            {this.props.taglayout != null &&
                                            <Modal show={this.state.editModal}
                                                   onHide={HF.closeModal.bind(this, "editModal")}
                                                   aria-labelledby="ModalHeader"
                                                   backdrop={false}
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader'
                                                                 className="headerTitle text-capitalize">Edit
                                                        TagLayout</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <AddEditTagLayoutForm
                                                                closeModel={HF.closeModal.bind(this, "editModal")}
                                                                formTypePro="edit"
                                                                requiredField={{
                                                                    tag_type: "required",
                                                                    barcode: "required",
                                                                    title: "required",
                                                                    description: "required",
                                                                    vendor_description: "required"
                                                                }}
                                                                tagObject={this.state.tag}
                                                                tagtypesProp={this.props.tagtypes}
                                                                tagProp={this.props.taglayout}
                                                                validatorInstance={this.validator}
                                                                returnState={this.getState}
                                                                handleFormSubmitProp={this.handleEditFormSubmit}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                            }
                                            {/*Edit Modal End*/}

                                            {/*Add Tag Type Modal Start*/}
                                            {this.props.TagLayoutData !== null &&
                                            <Modal show={this.state.tagTypeAddModal}
                                                   onHide={HF.closeModal.bind(this, "tagTypeAddModal")}
                                                   aria-labelledby="ModalHeader"
                                                   backdrop={false}
                                            >
                                                <Modal.Header closeButton>
                                                    <Modal.Title id='ModalHeader'
                                                                 className="headerTitle text-capitalize">Add Tag
                                                        Type</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="row">
                                                        <div className="col-md-8 col-md-offset-2">
                                                            <ListForm
                                                                closeModel={HF.closeModal.bind(this, "tagTypeAddModal")}
                                                                formTypePro="add"
                                                                listPro={{list: OC.list}}
                                                                handleListSubmit={this.handleTagTypeSubmit}
                                                                name={this.props.title}
                                                                componentPro={'List'}
                                                                parent_id={this.state.tagTypeParentId}
                                                            />
                                                        </div>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                            }
                                            {/*Add Tag Type Modal End*/}


                                        </div>
                                    }/>
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </React.Fragment>
        );
    };
}

const mapDispatchToProps = dispatch => {
    return ({
        getListCall: (
            id, page, filter, sort, pageSize, component_name, pagination
        ) => {
            dispatch(
                listActions.getList(
                    id, page, filter, sort, pageSize, component_name, pagination
                )
            );
        },
        getAllBrandsCall: custId => {
            dispatch(brandActions.getAllBrandsforCustomer(custId));
        },
        storeTagLayoutCall: data => {
            return dispatch(brandActions.storeCustomerTagLayout(data));
        },
        getAllTagLayoutsCall: (
            id, filter, page, sort, pageSize
        ) => {
            let resource_id = '';
            if (id !== undefined) {
                resource_id = id;
            } else {
                resource_id = 'all';
            }
            dispatch(
                brandActions.getBrandTagLayoutsPagination(
                    resource_id, filter, page, sort, pageSize
                )
            );
        },

        getTagLayoutCall: (id) => {
            return dispatch(brandActions.getTagLayout(id))
        },
        updateTagLayoutCall: (data, id) => {
            return dispatch(brandActions.editTagLayout(data, id))
        },
        deleteListCall: (id) => {
            return dispatch(brandActions.deleteTagLayout(id))
        },
        storeTagTypeCall: (listData) => {
            return dispatch(listActions.storeList(listData))
        }
    });
};

function mapStateToProps(state, ownProps) {
    const {taglayoutsData, taglayout, pages, current_page} = state.brandReducer;
    const {tagtype} = state.listReducer;

    return {
        taglayoutsData,
        tagtypes: tagtype,
        taglayout,
        pages,
        current_page
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TagLayouts));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/TagLayouts.jsx